export default __webpack_public_path__ + "static/media/6s.bde70af6.svg";